/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkProgress} from '../models/BulkProgress';
import type {Error} from '../models/Error';
import type {ProductSeatUpdateResult} from '../models/ProductSeatUpdateResult';
import type {UnassignProductSeatRequest} from '../models/UnassignProductSeatRequest';

export interface GetProductSeatUnassignBulkProgress$Request {
    id: string;
}

export interface GetProductSeatUnassignBulkProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getProductSeatUnassignBulkProgressRequest = createAction<PayloadData<void, GetProductSeatUnassignBulkProgress$Request>>('BULK_PRODUCT_SEAT_UNASSIGNMENT__GET_PRODUCT_SEAT_UNASSIGN_BULK_PROGRESS__REQUEST');
export const getProductSeatUnassignBulkProgressSuccess = createAction<PayloadData<BulkProgress, GetProductSeatUnassignBulkProgress$Request>>('BULK_PRODUCT_SEAT_UNASSIGNMENT__GET_PRODUCT_SEAT_UNASSIGN_BULK_PROGRESS__SUCCESS');
export const getProductSeatUnassignBulkProgressFailure = createAction<PayloadData<Error, GetProductSeatUnassignBulkProgress$Request, true>>('BULK_PRODUCT_SEAT_UNASSIGNMENT__GET_PRODUCT_SEAT_UNASSIGN_BULK_PROGRESS__FAILURE');

export const getProductSeatUnassignBulkProgressActions = [
    getProductSeatUnassignBulkProgressRequest,
    getProductSeatUnassignBulkProgressSuccess,
    getProductSeatUnassignBulkProgressFailure
] as const;

/**
 * @param {string} meta.id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getProductSeatUnassignBulkProgress = (meta: GetProductSeatUnassignBulkProgress$Request, config?: GetProductSeatUnassignBulkProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getProductSeatUnassignBulkProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/users/product-seats/unassign/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetProductSeatUnassignBulkResult$Request {
    id: string;
}

export interface GetProductSeatUnassignBulkResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getProductSeatUnassignBulkResultRequest = createAction<PayloadData<void, GetProductSeatUnassignBulkResult$Request>>('BULK_PRODUCT_SEAT_UNASSIGNMENT__GET_PRODUCT_SEAT_UNASSIGN_BULK_RESULT__REQUEST');
export const getProductSeatUnassignBulkResultSuccess = createAction<PayloadData<ProductSeatUpdateResult, GetProductSeatUnassignBulkResult$Request>>('BULK_PRODUCT_SEAT_UNASSIGNMENT__GET_PRODUCT_SEAT_UNASSIGN_BULK_RESULT__SUCCESS');
export const getProductSeatUnassignBulkResultFailure = createAction<PayloadData<Error, GetProductSeatUnassignBulkResult$Request, true>>('BULK_PRODUCT_SEAT_UNASSIGNMENT__GET_PRODUCT_SEAT_UNASSIGN_BULK_RESULT__FAILURE');

export const getProductSeatUnassignBulkResultActions = [
    getProductSeatUnassignBulkResultRequest,
    getProductSeatUnassignBulkResultSuccess,
    getProductSeatUnassignBulkResultFailure
] as const;

/**
 * @param {string} meta.id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getProductSeatUnassignBulkResult = (meta: GetProductSeatUnassignBulkResult$Request, config?: GetProductSeatUnassignBulkResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getProductSeatUnassignBulkResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/users/product-seats/unassign`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface StopProductSeatUnassignBulk$Request {
    id: string;
}

export interface StopProductSeatUnassignBulk$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const stopProductSeatUnassignBulkRequest = createAction<PayloadData<void, StopProductSeatUnassignBulk$Request>>('BULK_PRODUCT_SEAT_UNASSIGNMENT__STOP_PRODUCT_SEAT_UNASSIGN_BULK__REQUEST');
export const stopProductSeatUnassignBulkSuccess = createAction<PayloadData<void, StopProductSeatUnassignBulk$Request>>('BULK_PRODUCT_SEAT_UNASSIGNMENT__STOP_PRODUCT_SEAT_UNASSIGN_BULK__SUCCESS');
export const stopProductSeatUnassignBulkFailure = createAction<PayloadData<Error, StopProductSeatUnassignBulk$Request, true>>('BULK_PRODUCT_SEAT_UNASSIGNMENT__STOP_PRODUCT_SEAT_UNASSIGN_BULK__FAILURE');

export const stopProductSeatUnassignBulkActions = [
    stopProductSeatUnassignBulkRequest,
    stopProductSeatUnassignBulkSuccess,
    stopProductSeatUnassignBulkFailure
] as const;

/**
 * @param {string} meta.id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const stopProductSeatUnassignBulk = (meta: StopProductSeatUnassignBulk$Request, config?: StopProductSeatUnassignBulk$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: stopProductSeatUnassignBulkActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/bulk-actions/users/product-seats/unassign`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UnassignProductSeatBulk$Request {
    unassignProductSeatRequest: UnassignProductSeatRequest;
    reason?: string;
}

export interface UnassignProductSeatBulk$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const unassignProductSeatBulkRequest = createAction<PayloadData<void, UnassignProductSeatBulk$Request>>('BULK_PRODUCT_SEAT_UNASSIGNMENT__UNASSIGN_PRODUCT_SEAT_BULK__REQUEST');
export const unassignProductSeatBulkSuccess = createAction<PayloadData<string, UnassignProductSeatBulk$Request>>('BULK_PRODUCT_SEAT_UNASSIGNMENT__UNASSIGN_PRODUCT_SEAT_BULK__SUCCESS');
export const unassignProductSeatBulkFailure = createAction<PayloadData<Error, UnassignProductSeatBulk$Request, true>>('BULK_PRODUCT_SEAT_UNASSIGNMENT__UNASSIGN_PRODUCT_SEAT_BULK__FAILURE');

export const unassignProductSeatBulkActions = [
    unassignProductSeatBulkRequest,
    unassignProductSeatBulkSuccess,
    unassignProductSeatBulkFailure
] as const;

/**
 * @param {UnassignProductSeatRequest} meta.unassignProductSeatRequest
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const unassignProductSeatBulk = (meta: UnassignProductSeatBulk$Request, config?: UnassignProductSeatBulk$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: unassignProductSeatBulkActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/bulk-actions/users/product-seats/unassign`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.unassignProductSeatRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

